/* =====================================================================
   JS VANILLA — modules autonomes (aucun framework)
   ===================================================================== */
(function(){
  'use strict';

  // Dimensions naturelles de l'image hero courante (sert au calcul "cover" de la loupe)
  var heroNat = { w: 1000, h: 750 };
  // URL résolue de l'image hero (posée en inline sur la lentille -> indépendant du cascade CSS)
  var heroUrl = '';

  /* ------------------------------------------------------------------
     1) PLACEHOLDER DOODLE DU HERO (texture zoomable pour la loupe)
        Génère une scène schématique en gris (clairement un placeholder)
        et l'injecte dans la variable CSS --hero-img. Vic remplacera
        simplement cette variable par sa vraie illustration.
     ------------------------------------------------------------------ */
  function buildHeroPlaceholder(){
    var root  = getComputedStyle(document.documentElement);
    var bg    = (root.getPropertyValue('--ph-bg')  || '#e9ebef').trim();
    var ink   = (root.getPropertyValue('--ph-ink') || '#c9ced9').trim();
    var W = 1000, H = 750;   /* 4/3 paysage, comme .hero-screen */

    // PRNG déterministe (mulberry32) → layout stable d'un chargement à l'autre
    var seed = 0x9e3779b9 >>> 0;
    function rnd(){
      seed |= 0; seed = (seed + 0x6D2B79F5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    }

    // Petits doodles centrés sur (0,0)
    var shapes = [
      function(){ return "<circle cx='0' cy='0' r='12'/><path d='M0 12V22'/>"; },                         // ballon
      function(){ return "<path d='M0 -13L4 -4 14 -4 6 3 9 13 0 7 -9 13 -6 3 -14 -4 -4 -4Z'/>"; },        // étoile
      function(){ return "<circle r='13'/><circle r='4'/><path d='M0 -13V13M-13 0H13M-9 -9 9 9M-9 9 9 -9'/>"; }, // grande roue
      function(){ return "<path d='M-14 12L0 -12 14 12Z'/><path d='M0 -12V12'/>"; },                       // tente
      function(){ return "<circle cx='0' cy='-9' r='6'/><path d='M0 -3V9M-8 2 0 -1 8 2M-7 19 0 9 7 19'/>"; }, // personnage
      function(){ return "<path d='M-12 2C-12 -10 6 -12 6 -1 6 5 -3 6 -3 0'/>"; },                         // spirale
      function(){ return "<path d='M-16 -7Q0 3 16 -7'/><path d='M-10 -5 -7 3 -3 -4M3 -4 7 3 10 -5'/>"; },  // guirlande
      function(){ return "<rect x='-10' y='-10' width='20' height='20' rx='4'/><path d='M-10 0H10M0 -10V10'/>"; } // cadeau
    ];

    var parts = [], step = 92;
    for(var y = 46; y < H - 20; y += step){
      for(var x = 46; x < W - 20; x += step){
        var jx = x + (rnd() - .5) * 44;
        var jy = y + (rnd() - .5) * 44;
        var f  = shapes[Math.floor(rnd() * shapes.length)];
        var s  = (0.7 + rnd() * 0.7).toFixed(2);
        var rot= (rnd() * 44 - 22).toFixed(1);
        parts.push("<g transform='translate(" + jx.toFixed(1) + " " + jy.toFixed(1) +
                   ") rotate(" + rot + ") scale(" + s + ")'>" + f() + "</g>");
      }
    }

    var svg =
      "<svg xmlns='http://www.w3.org/2000/svg' width='" + W + "' height='" + H +
      "' viewBox='0 0 " + W + " " + H + "'>" +
      "<rect width='" + W + "' height='" + H + "' fill='" + bg + "'/>" +
      "<g fill='none' stroke='" + ink + "' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'>" +
      parts.join('') + "</g></svg>";

    var uri = "url(\"data:image/svg+xml," + encodeURIComponent(svg) + "\")";
    document.documentElement.style.setProperty('--hero-img', uri);
  }

  /* ------------------------------------------------------------------
     1bis) VRAIE IMAGE DU HERO — branche assets/hero-scene.webp ; si le
           fichier est absent, on retombe sur le placeholder doodle.
           Mémorise les dimensions naturelles pour la maths "cover" de la loupe.
     ------------------------------------------------------------------ */
  function setHeroImage(){
    // L'image du hero est posée par la SECTION (variable CSS --hero-img sur .hero-screen,
    // via réglage image_picker ou asset du thème). On lit l'URL appliquée juste pour
    // mesurer le ratio (maths "cover" de la loupe) — on ne réécrit PAS --hero-img.
    var screen = document.querySelector('[data-loupe]') || document.querySelector('.hero-screen');
    var url = '';
    if(screen){
      var v = getComputedStyle(screen).getPropertyValue('--hero-img');
      var m = v && v.match(/url\((['"]?)(.*?)\1\)/);
      if(m){ url = m[2]; }
    }
    if(!url && window.MLL){
      url = window.matchMedia('(max-width: 768px)').matches ? window.MLL.heroMobile : window.MLL.heroDesktop;
    }
    if(!url){ buildHeroPlaceholder(); heroNat.w = 1000; heroNat.h = 750; return; }
    heroUrl = url;                       // mémorisé pour la lentille (fond posé en inline)
    var probe = new Image();
    probe.onload  = function(){ if(probe.naturalWidth){ heroNat.w = probe.naturalWidth; heroNat.h = probe.naturalHeight; } };
    probe.onerror = function(){ heroNat.w = 5656; heroNat.h = 4454; };   // ratio 5:4 connu en secours
    probe.src = url;
  }

  /* ------------------------------------------------------------------
     2) LOUPE DU HERO — lentille circulaire qui suit le curseur (desktop
        au survol, mobile au tap/drag via le bouton "Passez la loupe").
     ------------------------------------------------------------------ */
  function initLoupe(){
    var wrap = document.querySelector('[data-loupe]');
    if(!wrap) return;
    var screen  = wrap;                                  // .hero-screen
    var lens    = wrap.querySelector('.loupe-lens');
    var trigger = wrap.querySelector('[data-loupe-trigger]');
    if(!lens || !trigger) return;
    var ZOOM    = 2.5;                                   // ~2.5x : détails (code promo caché) lisibles
    var armed   = false;                                 // loupe active (tactile)
    var canHover= window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    // FILET DE SÉCURITÉ Shopify : on impose taille + image de la lentille en INLINE.
    // Dans le thème Dawn, une règle pouvait écraser la largeur (lentille rendue 0px =
    // invisible) ou la variable --hero-img n'était pas héritée. En posant ces valeurs
    // en inline (priorité maximale hors !important), la loupe s'affiche à coup sûr.
    function lensSize(){
      var w = window.innerWidth;
      if(w <= 480) return 132;
      if(w <= 820) return 104;
      return 168;
    }
    function applyLens(){
      var s = lensSize();
      lens.style.width  = s + 'px';
      lens.style.height = s + 'px';
      if(heroUrl) lens.style.backgroundImage = 'url("' + heroUrl + '")';
    }
    applyLens();
    window.addEventListener('resize', applyLens);
    // épaisseur du cadre noir (la lentille et l'image sont à l'INTÉRIEUR du cadre)
    var bw = parseFloat(getComputedStyle(screen).borderLeftWidth) || 0;
    var bt = parseFloat(getComputedStyle(screen).borderTopWidth)  || 0;

    // Place la lentille. En tactile (touch=true) on la DÉCALE du doigt : la zone
    // grossie reste visible au-dessus (ou en dessous) du doigt, jamais cachée par lui.
    function move(clientX, clientY, touch){
      var r = screen.getBoundingClientRect();
      var W = r.width  - bw * 2, H = r.height - bt * 2;        // zone image (intérieur du cadre)
      var x = Math.max(0, Math.min(clientX - r.left - bw, W)); // point grossi (sous le doigt)
      var y = Math.max(0, Math.min(clientY - r.top  - bt, H));
      var lr = lens.offsetWidth / 2;
      var lx = x, ly = y;
      if(touch){
        // Pas de bascule : la lentille flotte TOUJOURS au-dessus du doigt et reste
        // dans l'image. On supprime le "renvoi au côté opposé" à mi-hauteur (le bug).
        var off = lr + 20;                                    // la lentille flotte au-dessus du doigt
        lx = Math.max(lr, Math.min(W - lr, x));
        ly = Math.max(lr, Math.min(H - lr, y - off));
      }
      lens.style.left = lx + 'px';
      lens.style.top  = ly + 'px';
      var s     = Math.max(W / heroNat.w, H / heroNat.h);      // échelle "cover"
      var dispW = heroNat.w * s, dispH = heroNat.h * s;        // taille affichée de l'image
      var ox    = (W - dispW) / 2, oy = (H - dispH) / 2;       // décalage du recadrage (<= 0)
      // La zone affichée au CENTRE de la lentille = le point (x,y) sous le doigt
      // (indépendant de la position d'affichage lx,ly de la lentille).
      lens.style.backgroundSize     = (dispW * ZOOM) + 'px ' + (dispH * ZOOM) + 'px';
      lens.style.backgroundPosition = (lr - (x - ox) * ZOOM) + 'px ' + (lr - (y - oy) * ZOOM) + 'px';
    }
    function show(){ lens.classList.add('is-on'); }
    function hide(){ lens.classList.remove('is-on'); }

    // Desktop : survol — lentille au curseur (le curseur fin ne masque rien)
    if(canHover){
      screen.addEventListener('mouseenter', show);
      screen.addEventListener('mouseleave', function(){ if(!armed) hide(); });
      screen.addEventListener('mousemove', function(e){ move(e.clientX, e.clientY, false); });
    } else {
      var txt = trigger.querySelector('.ov-loupe-txt');   // libellé explicite sur mobile
      if(txt) txt.textContent = 'Cliquez pour passer la loupe';
    }

    // Bouton "Passez la loupe" → arme/désarme le mode tactile
    function setArmed(on){
      armed = on;
      trigger.classList.toggle('is-armed', on);
      trigger.setAttribute('aria-pressed', on ? 'true' : 'false');
      screen.style.touchAction = on ? 'none' : '';
      if(!canHover) trigger.style.display = on ? 'none' : '';   // mobile : on masque le bandeau qui gêne le visuel
      if(on){
        var r = screen.getBoundingClientRect();
        move(r.left + r.width/2, r.top + r.height*0.62, !canHover);   // position initiale
        show();
      } else { hide(); }
    }
    trigger.addEventListener('click', function(e){ e.preventDefault(); setArmed(!armed); });

    // Tactile : glisser le doigt sur l'image quand la loupe est armée (lentille décalée).
    // Un simple tap (sans glisser) range la loupe et fait réapparaître le bouton.
    var tx0 = 0, ty0 = 0, tMoved = false;
    screen.addEventListener('touchstart', function(e){
      if(!armed) return;
      var t = e.touches[0];
      tx0 = t.clientX; ty0 = t.clientY; tMoved = false;
      move(t.clientX, t.clientY, true);
    }, { passive:true });
    screen.addEventListener('touchmove', function(e){
      if(!armed) return;
      e.preventDefault();
      var t = e.touches[0];
      if(Math.abs(t.clientX - tx0) > 10 || Math.abs(t.clientY - ty0) > 10) tMoved = true;
      move(t.clientX, t.clientY, true);
    }, { passive:false });
    screen.addEventListener('touchend', function(){
      if(armed && !tMoved) setArmed(false);   // tap simple -> on range la loupe (le bouton revient)
    }, { passive:true });
  }

  /* ------------------------------------------------------------------
     3) FAQ — accordéon (une seule question ouverte à la fois)
     ------------------------------------------------------------------ */
  function initFaq(){
    var items = Array.prototype.slice.call(document.querySelectorAll('.faq-item'));
    items.forEach(function(item){
      var btn = item.querySelector('.faq-q');
      var ans = item.querySelector('.faq-a');
      btn.addEventListener('click', function(){
        var isOpen = item.classList.contains('is-open');
        items.forEach(function(other){
          other.classList.remove('is-open');
          other.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
          other.querySelector('.faq-a').style.maxHeight = null;
        });
        if(!isOpen){
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          ans.style.maxHeight = ans.scrollHeight + 'px';
        }
      });
    });
    // Recalcule la hauteur ouverte au redimensionnement
    window.addEventListener('resize', function(){
      var open = document.querySelector('.faq-item.is-open .faq-a');
      if(open) open.style.maxHeight = open.scrollHeight + 'px';
    });
  }

  /* ------------------------------------------------------------------
     4) CARROUSEL AVIS — flèches précédent / suivant
     ------------------------------------------------------------------ */
  function initAvis(){
    var track = document.getElementById('avisTrack');
    if(!track) return;
    document.querySelectorAll('[data-avis]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var dir = parseInt(btn.getAttribute('data-avis'), 10);
        var card = track.querySelector('.avis-card');
        var step = card ? (card.offsetWidth + 22) : 320;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
    });
  }

  /* Carrousel avant/après — flèches précédent / suivant (1 slide = 1 montage) */
  function initAvap(){
    var track = document.getElementById('avapTrack');
    if(!track) return;
    document.querySelectorAll('[data-avap]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var dir = parseInt(btn.getAttribute('data-avap'), 10);
        var slide = track.querySelector('.avap-slide');
        var step = slide ? (slide.offsetWidth + 20) : 400;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
    });
  }

  /* Carrousel "Le rendu en vrai" — autoplay + flèches latérales. Boucle infinie
     fluide grâce à un clone à chaque extrémité ; le transform est piloté en JS. */
  function initRendu(){
    var carousel = document.querySelector('[data-rendu-carousel]');
    if(!carousel) return;
    var track = carousel.querySelector('.rendu-track');
    if(!track) return;
    var reals = Array.prototype.slice.call(track.children);
    var N = reals.length;
    if(N < 2) return;
    // Clones aux deux bouts : on peut boucler sans à-coup dans les deux sens
    var firstClone = reals[0].cloneNode(true);
    var lastClone  = reals[N - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    track.appendChild(firstClone);
    track.insertBefore(lastClone, reals[0]);
    var index = 1;                 // 0 = clone de fin ; 1 = 1ère vraie image
    var animating = false;
    function place(animate){
      track.style.transition = animate ? 'transform .5s ease' : 'none';
      track.style.transform  = 'translateX(' + (-index * 100) + '%)';
    }
    place(false);
    function go(dir){
      if(animating) return;
      animating = true;
      index += dir;
      place(true);
    }
    track.addEventListener('transitionend', function(){
      animating = false;
      if(index === N + 1){ index = 1; place(false); }       // après le clone de fin -> 1ère vraie
      else if(index === 0){ index = N; place(false); }      // avant le clone de début -> dernière vraie
    });
    // Autoplay (repris au survol / après un clic sur une flèche)
    var timer = null;
    function start(){ stop(); timer = setInterval(function(){ go(1); }, 4500); }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.querySelectorAll('[data-rendu]').forEach(function(btn){
      btn.addEventListener('click', function(){
        go(parseInt(btn.getAttribute('data-rendu'), 10));
        start();
      });
    });
    // N'anime que lorsque le carrousel est visible (économie de ressources)
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(e){ e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.2 }).observe(carousel);
    } else { start(); }
  }

  /* ------------------------------------------------------------------
     5) FALLBACK IMAGES — si une vraie image ne charge pas, on affiche
        un placeholder étiqueté (robustesse hors-ligne / CDN indispo).
     ------------------------------------------------------------------ */
  function initImageFallback(){
    document.querySelectorAll('img').forEach(function(img){
      img.addEventListener('error', function(){
        if(img.dataset.failed) return;
        img.dataset.failed = '1';
        var label = (img.getAttribute('alt') || 'Image').slice(0, 40);
        var svg =
          "<svg xmlns='http://www.w3.org/2000/svg' width='400' height='400'>" +
          "<rect width='400' height='400' fill='#e9ebef'/>" +
          "<text x='50%' y='46%' fill='#99a1ad' font-family='sans-serif' font-size='17' font-weight='700' text-anchor='middle'>[ IMAGE NON CHARGEE ]</text>" +
          "<text x='50%' y='55%' fill='#99a1ad' font-family='sans-serif' font-size='13' text-anchor='middle'>" + label + "</text></svg>";
        img.src = "data:image/svg+xml," + encodeURIComponent(svg);
      }, { once:true });
    });
  }

  /* ------------------------------------------------------------------
     6) MENU MOBILE (en-tête) — le burger ouvre/ferme la nav déroulante.
        Accessible : bascule la classe .is-open sur l'en-tête + aria-expanded
        sur le bouton. Le CSS (section mll-header) affiche la nav en panneau
        sous la barre à ≤860px. Fermeture au clic dehors, sur Échap, et au
        passage en desktop (>860px).
     ------------------------------------------------------------------ */
  function initHeaderMenu(){
    var header = document.querySelector('[data-mll-header]');
    if(!header) return;
    var burger = header.querySelector('[data-mll-burger]');
    if(!burger) return;

    function setOpen(open){
      header.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    burger.addEventListener('click', function(e){
      e.preventDefault();
      setOpen(!header.classList.contains('is-open'));
    });

    // Clic en dehors de l'en-tête -> on referme
    document.addEventListener('click', function(e){
      if(header.classList.contains('is-open') && !header.contains(e.target)){
        setOpen(false);
      }
    });

    // Touche Échap -> on referme et on redonne le focus au burger
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && header.classList.contains('is-open')){
        setOpen(false);
        burger.focus();
      }
    });

    // Repassage en desktop -> on s'assure que l'état ouvert est nettoyé
    window.matchMedia('(min-width: 861px)').addEventListener('change', function(ev){
      if(ev.matches) setOpen(false);
    });
  }

  /* ------------------------------------------------------------------
     Démarrage
     ------------------------------------------------------------------ */
  function init(){
    setHeroImage();        // vraie image hero (fallback placeholder doodle si absente)
    initLoupe();
    initFaq();
    initAvis();
    initAvap();
    initRendu();
    initImageFallback();
    initHeaderMenu();      // burger -> menu mobile déroulant
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
